import { Languages } from '@chiroup/core/enums/Languages.enum';
import { Exercise } from '@chiroup/core/types/Exercise.type';
import React from 'react';
import ReportPrintExercise from './ReportPrintExercise';
import ReportPrintHeader from './ReportPrintHeader';

type Props = {
  title: string;
  exercises: Exercise[];
  language: Languages;
  primaryColor?: string;
  pdf?: boolean;
  between?: React.ReactNode;
  small?: boolean;
};

const ReportPrintExercises: React.FC<Props> = ({
  title,
  exercises,
  language,
  primaryColor,
  pdf,
  between,
  small,
}) => {
  return (
    <>
      {exercises.map((exer, index) => (
        <div key={exer.$uiid} className="avoid-break">
          {index === 0 && (
            <>
              <ReportPrintHeader
                title={title}
                primaryColor={primaryColor}
                pdf={pdf}
                small={small}
              />
              {between}
            </>
          )}
          {pdf && <div className="mt-4" />}
          <ReportPrintExercise
            index={index}
            exercise={exer}
            language={language}
            primaryColor={primaryColor}
            small={small}
          />
        </div>
      ))}
    </>
  );
};

export default ReportPrintExercises;
